<template>
  <div>
    <v-card elevation="0">
      <Bar
        :chart-options="chartData.options"
        :chart-data="chartData.data"
        :plugins="chartData.plugins"
        chart-id="myChart2"
        dataset-id-key="label"
        :height="150"
      />
      <v-snackbar v-model="isError" color="error" top>
        <v-icon left size="18">mdi-information</v-icon>{{ $t('error') }}
      </v-snackbar>
    </v-card>
	</div>
</template>
<script>
import { mapState } from "vuex";
import Layout from "@/components/Layout.vue";
import { DigitalMeterReport , Meter } from "../classes"
import meterReport from "../json/meterData.json"
import { Bar } from 'vue-chartjs/legacy'
export default {
  props: {
    selectedMonthYear: Object
  },
	components: {
		Layout,
    Bar
	},
  data() {
    return {
			projectId: this.$route.params.projectId,
			isLoading: false,
			isError: false,
      project: null,
      markets: null,
      color: [
        "rgba(3, 208, 44, .7)",
        "rgba(84, 184, 193, .7)",
        "rgba(251, 65, 108, .7)",
        "rgba(251, 83, 8, .7)",
        "rgba(1, 27, 155, .7)",
        "rgba(240, 250, 19, .7)",
        "rgba(131, 63, 18, .7)",
        "rgba(15, 34, 38, .7)",
        "rgba(66, 155, 99, .7)"
      ],
      meter: null,
      chartData: {
        data: {
          labels: [],
          datasets: []
        },
        options: {}
      }
    }
  },
  computed: {
    ...mapState({
      sessionAdmins: (state) => state.admin.sessionAdmins,
      meters: (state) => state.meter.meters,
      meterReports: (state) => state.digitalMeterReport.meterReports,
    }),
    admins() {
      return this.$store.getters["admin/getByProjectId"](this.projectId);
    },
  },
  mounted(){
    this.initData()
  },
	methods: {
    prepareData(meter){
      if(this.meters && this.meterReports){
        this.chartData.data.labels = []
        this.chartData.data.datasets = []
        

        let mm = this.$moment({month: this.selectedMonthYear.month - 1, year: this.selectedMonthYear.year})
        let hashMeter = {}
        let hashMarket = {}
        for(let meter of this.meters){
          if(meter.digitalMeterData){
            hashMeter[`${meter.digitalMeterData.cust_id}_${meter.digitalMeterData.meter_id}`] = meter
          }
        }

        for(let i = 1; i <= mm.daysInMonth(); i++){
          let now = this.$moment({ days: i, month: this.selectedMonthYear.month - 1, year: this.selectedMonthYear.year })
          let previous = this.$moment({ days: i, month: this.selectedMonthYear.month - 1, year: this.selectedMonthYear.year }).subtract(1, "days")
          
          let _now = this.$moment(now).format("YYYY-MM-DD")
          let _previous = this.$moment(previous).format("YYYY-MM-DD")
          for(let _meterReport of this.meterReports){
            let previousRecord = _meterReport.reverse().find(d => d.tb_date == _previous)
            let nowRecord = _meterReport.reverse().find(d => d.tb_date == _now)

            if(nowRecord){
              for(let x = 1; x <= 256; x++){
                if(nowRecord && nowRecord["tb_kWh" + x]){
                  let meter = hashMeter[`${nowRecord.cust_id}_${x}`]
                  if(meter){
                    
                    let unit =  parseFloat(nowRecord["tb_kWh" + x])
                    let previousUnit = previousRecord && previousRecord["tb_kWh" + x] ? parseFloat(previousRecord["tb_kWh" + x]) : 0

                    if(!hashMarket[meter.market.objectId]){
                      hashMarket[meter.market.objectId] = {
                        market: this.markets.find(d => d.objectId == meter.market.objectId),
                        data: []
                      }
                    }
                    if(!hashMarket[meter.market.objectId].data[i - 1]) hashMarket[meter.market.objectId].data[i - 1] = 0
                    hashMarket[meter.market.objectId].data[i - 1] += parseFloat((unit - previousUnit).toFixed(2))
                  }
                }
              }
            }
          }
          this.chartData.data.labels.push(now.format("D/M/YY"))
        }

        
        let index = 0
        for(let key in hashMarket){
          this.chartData.data.datasets.push({
            label: hashMarket[key].market.name,
            data: hashMarket[key].data,
            backgroundColor: this.color[index],
          })
          index++
        }

        this.chartData.options = {
          interaction: {
            mode: "index"
          },
          responsive: true,
          scales: {
            x: {
              stacked: true,
              title: {
                display: true,
                text: this.$t('date')
              },
            },
            y: {
              stacked: true,
              title: {
                display: true,
                text: this.$t('unit')
              },
            }
          },
          plugins: {
            tooltip: {
              callbacks: {
                label: (context) => {
                  if(context.parsed.y)
                    return `${context.dataset.label} ${context.parsed.y} ${this.$t('unit')}`
                },
                footer: (tooltipItems) => {
                  let total = 0
                  for(let dataset of this.chartData.data.datasets){
                    if(dataset.data[tooltipItems[0].dataIndex]) total +=dataset.data[tooltipItems[0].dataIndex]
                  }
                  return `${this.$t('sum')} : ${total.toFixed(2)} ${this.$t('unit')}`;
                },
              }
            }
          }
        }
      }
      
    },
		async initData(){
			this.isLoading = true
			try {
        if(this.admins){
          this.project = this.admins[0].project
          this.markets = this.admins.map(d => d.market)
        }
        this.prepareData()
				this.isLoading = false
			} catch(error) {
				this.isLoading = false
				this.isError = true
			}
		},
    changeMeter(meter){
      this.meter = meter
      this.prepareData(meter)
    }
	}
}
</script>
